import { render } from "./PotEffectChart.vue?vue&type=template&id=2e437990&ts=true"
import script from "./PotEffectChart.vue?vue&type=script&lang=ts"
export * from "./PotEffectChart.vue?vue&type=script&lang=ts"

import "./PotEffectChart.vue?vue&type=style&index=0&id=2e437990&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__